"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountClosureType = exports.AccountClosureFrontendDisplayStatus = exports.AccountClosureFrontendDisplayType = void 0;
var AccountClosureFrontendDisplayType;
(function (AccountClosureFrontendDisplayType) {
    AccountClosureFrontendDisplayType["regular"] = "regular";
    // only show credit balance refund step if the account has a credit balance
    AccountClosureFrontendDisplayType["withCreditBalanceRefund"] = "withCreditBalanceRefund";
    // only show the banner at the top of the page with only text (no button), currently used for UCC accounts
    AccountClosureFrontendDisplayType["textBannerOnly"] = "textBannerOnly";
})(AccountClosureFrontendDisplayType || (exports.AccountClosureFrontendDisplayType = AccountClosureFrontendDisplayType = {}));
var AccountClosureFrontendDisplayStatus;
(function (AccountClosureFrontendDisplayStatus) {
    // This status is base state where all checkboxes are empty, doesnt correspond to a step in the UI.
    AccountClosureFrontendDisplayStatus["payoffDemandSent"] = "payoffDemandSent";
    AccountClosureFrontendDisplayStatus["payoffReceived"] = "payoffReceived";
    // closed_on_corecard
    AccountClosureFrontendDisplayStatus["preparingPaperwork"] = "preparingPaperwork";
    // reconveyance_submitted
    AccountClosureFrontendDisplayStatus["submittedToCounty"] = "submittedToCounty";
    // reconveyance_recorded
    AccountClosureFrontendDisplayStatus["lienReleased"] = "lienReleased";
    // This status sequentially follows lienReleased, but technically credit balance refunds are issued parallel to lien release.
    // It may be possible that credit balance refunds are issued before lien release, but based on calls customers care much more
    // about the lien release, and ask about credit balance refund only after.
    // Thus we will be showing credit balance refund as sequential to lien release for a cleaner UI, and we are okay if it is slightly inaccurate.
    AccountClosureFrontendDisplayStatus["creditBalanceRefundIssued"] = "creditBalanceRefundIssued";
})(AccountClosureFrontendDisplayStatus || (exports.AccountClosureFrontendDisplayStatus = AccountClosureFrontendDisplayStatus = {}));
// For 'keep_card' type, the idea is that for home card, we want the customer to still keep the card (e.g. with a small credit line)
// if their main goal is refinancing, and make it easier for them to come back to fully re-apply.
// 'keep_card' is still planning/WIP.
var AccountClosureType;
(function (AccountClosureType) {
    AccountClosureType["PERMANENT_CLOSE"] = "permanent_close";
    /** @deprecated we cannot keep cards open after payoff and switch products, it is very complicated with cap markets partners */
    AccountClosureType["_KEEP_CARD"] = "keep_card";
    AccountClosureType["IN_RESCISSION"] = "in_rescission";
})(AccountClosureType || (exports.AccountClosureType = AccountClosureType = {}));
